import actionTypes from '../../action-types'

export default (page, filter) => ({
  type: actionTypes.ADMINISTRATORS.FETCH_ALL,
  meta: {
    page,
    filter,
  },
})
